import { z } from "zod";

export const ALLOWED_FILE_EXTENSIONS = [
	"pdf",
	"doc",
	"docx",
	"png",
	"jpg",
	"jpeg",
	"webp",
] as const;
export const ALLOWED_FILE_TYPES = [
	"application/pdf",
	"application/msword",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"image/png",
	"image/jpeg",
	"image/jpg",
	"image/webp",
] as const;

export const MAX_ALLOWED_FILE_SIZE = 1024 * 1024 * 2; // 2 MB in bytes

export const DocumentTypeSchema = z.enum([
	"MEDICAL_SUMMARY",
	"MEDICATION_REPORT",
	"DOCTOR_RECOMMENDATION",
	"CONSUMPTION_TABLE",
	"ID",
	"CANNABIS_LICENSE",
	"PRESCRIPTIONS",
	"CUSTOM1",
	"CUSTOM2",
	"CUSTOM3",
]);
export type TDocumentType = z.infer<typeof DocumentTypeSchema>;

export type TDocument = {
	type: TDocumentType;
	url: string;
	name: string;
	path: string;
	label?: string;
	createdAt: number;
	fileType: (typeof ALLOWED_FILE_TYPES)[number];
	extension: (typeof ALLOWED_FILE_EXTENSIONS)[number];
	size: number;
	pdfVersion?: TDocument; // Self-referential for PDF version of images
};

export const DocumentSchema: z.ZodType<TDocument> = z.object({
	type: DocumentTypeSchema,
	url: z.string().min(1),
	name: z.string().min(1),
	path: z.string().min(1),
	label: z.string().min(1).optional(),
	createdAt: z.number(),
	fileType: z.enum(ALLOWED_FILE_TYPES),
	extension: z.enum(ALLOWED_FILE_EXTENSIONS),
	size: z.number().positive(),
	pdfVersion: z.lazy(() => DocumentSchema).optional(),
});
